<template>
  <div class="prescriptionData">
    <!-- “prescriptionData”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
    >
    </sirui-search>
    <!-- raw -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template v-if="item.field == 'confimProductNameSpec'" v-slot:content="{ row }">
            <div class="childDataTable">
              <vxe-table
                resizable
                :auto-resize="true"
                border
                :data="showChild(row)"
                :valid-config="{ autoPos: true, message: 'inline' }"
              >
                <vxe-table-column
                  v-for="childs in column"
                  :key="childs.field"
                  :width="childs.width || 120"
                  :field="childs.field"
                  :title="childs.title"
                >
                </vxe-table-column>
              </vxe-table>
            </div>
          </template>
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 导入 -->
    <sirui-upload
      :data="importData"
      :action="importUrl"
      fileList=".xls,.xlsx"
      v-on:getData="getData"
      ref="siruiUpload"
    >
    </sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/rawData';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import siruiUpload from '@/components/SiruiUpload';
  // import DictSpan from '@/components/DictSpan';
  import XEUtils from 'xe-utils';
  export default {
    name: 'productionDataList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
      siruiUpload,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 状态 => 用于表格回显
        requestStatusData(state) {
          let dictList = state.dict.dictList;
          if (dictList.length > 0) {
            return dictList.find((it) => it.dictType == 'request_status').dictList;
          } else {
            return [];
          }
        },
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },

      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   产品编号
          {
            name: this.$t('productionList.search.productCode'),
            prop: 'productCode',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   产品名称
          {
            name: this.$t('productionList.search.productName'),
            prop: 'productName',
            type: 'input',
            //querySearch: this.productNameSearch
          },
          //   产品类别
          {
            name: this.$t('productionList.search.productCategory'),
            prop: 'productCategory',
            type: 'dict',
            dictType: 'product_type',
          },
          //   品牌
          {
            name: this.$t('productionList.search.productBrand'),
            prop: 'productBrand',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   校准名称
          {
            name: this.$t('productionList.search.productConfirmName'),
            prop: 'productConfirmName',
            type: 'input',
            //querySearch: this.productConfirmNameSearch
          },
          //   校准型号
          {
            name: this.$t('productionList.search.confimProductNameSpec'),
            prop: 'confimProductNameSpec',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   数据状态
          {
            name: this.$t('productionList.search.productStatus'),
            prop: 'productStatus',
            type: 'dict',
            dictType: 'produce_product_status',
          },
          //   规格型号
          {
            name: this.$t('productionList.search.productSpec'),
            prop: 'productSpec',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   其他
          {
            name: this.$t('productionList.search.otherInfo'),
            prop: 'otherInfo',
            type: 'input',
          },
          //   项目名称
          {
            name: this.$t('productionList.search.projectName'),
            prop: 'projectCode',
            type: 'dict',
            dictType: 'produce_product_proname',
          },
        ];
      },
    },
    data() {
      return {
        multipleSelection: [],
        importData: {}, // 导入参数
        importUrl: '', // 导入地址
        searchForm: {
          productClass: '1',
          productCode: null,
          productName: null,
          productType: null,
          productCategory: null,
          productConfirmName: null,
          confimProductNameSpec: null,
          productStatus: null,
          projectCode: null,
          projectName: null,
          costType: null,
          otherInfo: null,
        },
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'productCode',
            title: 'productionList.label.productCode',
            visible: true,
            width: 110,
          },
          {
            field: 'productName',
            title: 'productionList.label.productName',
            visible: true,
            width: 130,
          },
          {
            field: 'productStatus',
            title: 'rawData.label.productStatus',
            visible: true,
            width: 130,
            dictType: 'produce_product_status',
          },
          {
            field: 'productCategory',
            title: 'productionList.label.productCategory',
            visible: true,
            width: 100,
            dictType: 'product_type',
          },
          {
            field: 'productBrand',
            title: 'productionList.label.productBrand',
            visible: true,
            width: 130,
          },
          {
            field: 'otherInfo',
            title: 'productionList.label.otherInfo',
            visible: true,
            width: 120,
          },
          {
            field: 'productSpec',
            title: 'productionList.label.productSpec',
            visible: true,
            width: 140,
          },
          {
            field: 'projectCode',
            title: 'productionList.label.projectName',
            visible: true,
            width: 140,
            dictType: 'produce_product_proname',
          },
          {
            type: 'expand',
            field: 'confimProductNameSpec',
            title: 'productionList.label.productConfirmName',
            visible: true,
          },
        ],
        column: [
          /* {
          type: "seq",
          width: 80,
          title: this.$t("rawData.table.projectCode"),
        }, */
          {
            field: 'productName',
            title: this.$t('productionList.table.productConfirmName'),
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productSpec',
            title: this.$t('productionList.table.confimProductNameSpec'),
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productCategory',
            title: this.$t('productionList.table.confimProductCategory'),
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productBrand',
            title: this.$t('productionList.table.confimProductBrand'),
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'otherInfo',
            title: this.$t('productionList.table.confimOtherInfo'),
            width: 200,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      /* this.getProductCodeList(),
    this.getProductNameList(),
    this.getProductConfirmNameList(), */
      this.$nextTick(() => {
        //查询列表数据
        this.getData();
        //动态获取查询结果按钮及表头
        this.getButtonList();
        //设置导入参数
        this.setImport();
      });
    },
    methods: {
      // 获取列表数据
      getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const { adminFlag, tenantCode } = this.userInfo;
        let params = { pageNum, pageSize, adminFlag, tenantCode };
        params = Object.assign(params, this.searchForm);
        this.$axios.post(API.LIST_FUND_COLLECTION_REGISTER_BY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
            //重新加载表格
            this.$refs.siruiTable.reloadTable(this.tableData);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取产品编号列表
      getProductCodeList() {
        const params = {
          cloumn: 'productCode',
          productClass: '1',
        };
        this.$axios.get(API.PD_SELECT_OPTION, params).then((res) => {
          if (res.data.code === 0) {
            this.productCodeList = res.data.data;
          }
        });
      },
      // 获取产品名称列表
      getProductNameList() {
        const params = {
          cloumn: 'productName',
          productClass: '1',
        };
        this.$axios.get(API.PD_SELECT_OPTION, params).then((res) => {
          if (res.data.code === 0) {
            this.productNameList = res.data.data;
          }
        });
      },
      // 校准名称列表
      getProductConfirmNameList() {
        const params = {
          cloumn: 'productConfirmName',
          productClass: '1',
        };
        this.$axios.get(API.PD_SELECT_OPTION_ALIAS, params).then((res) => {
          if (res.data.code === 0) {
            this.productConfirmNameList = res.data.data;
          }
        });
      },
      // 产品编号模糊查询
      productCodeSearch(queryString, cb) {
        const productCodeList = this.productCodeList;
        const results = queryString
          ? productCodeList.filter(this.createFilter(queryString))
          : productCodeList;
        cb(results);
      },
      // 产品名称模糊查询
      productNameSearch(queryString, cb) {
        const productNameList = this.productNameList;
        const results = queryString
          ? productNameList.filter(this.createFilter(queryString))
          : productNameList;
        cb(results);
      },
      // 校准名称模糊查询
      pproductConfirmNameSearch(queryString, cb) {
        const productConfirmNameList = this.productConfirmNameList;
        const results = queryString
          ? productConfirmNameList.filter(this.createFilter(queryString))
          : productConfirmNameList;
        cb(results);
      },
      createFilter(queryString) {
        return (data) => {
          return data.value.indexOf(queryString) !== -1;
        };
      },
      // 获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      // 获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      getDictList() {
        // 公司名称
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.slipCompanyList = res.data.data;
            }
          });
      },
      chooseClick(value) {
        if (value === 'add') {
          //增加
          this.handleAdd();
        } else if (value === 'importData') {
          //批量导入
          this.handleImport();
        } else if (value === 'exportData') {
          //批量导出
          this.handleExport();
        } else if (value === 'del') {
          //批量删除
          this.handleForbid();
        }
      },
      // 新增
      handleAdd() {
        this.$baseRequest.linkRouteUrl(
          '/production/productionDataAdd',
          'productionDataAdd',
          '新增产品主数据明细'
        );
      },
      // 导出
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = 'ids=';
          // let ids = changeList.forEach((item) => {
          //   str += '' + item.id + ',';
          // });
          str = str.substring(0, str.lastIndexOf(','));
          window.location.href = `${this.baseUrl}${API.EXPORT_PRODUCT}?${str}&access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.searchForm);
          window.location.href = `${this.baseUrl}${API.EXPORT_PRODUCT}?${params}&access_token=${this.token.access_token}`;
        }
      },
      handleForbid() {
        if (this.multipleSelection.length > 0) {
          let productCode = [];
          for (let item of this.multipleSelection) {
            if (item.productStatus !== '001') {
              productCode.push(item.productCode);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('productionList.message.delete_to_enable'),
                type: 'error',
              });
              return false;
            }
          }
          const params = { delCodes: productCode };
          this.$confirmAction(this.$t('confirm.delete'))
            .then(() => {
              this.$axios.post(API.DELETE_PRODUCT, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('productionList.message.deleteSuccess'),
                    type: 'success',
                  });
                  this.multipleSelection = [];
                  this.$refs.siruiTable.clearCheckboxRow();
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('productionList.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 设置导入配置
      setImport() {
        this.importUrl = API.IMPORT_PRODUCT;
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo;
        this.importData = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          productClass: '1',
        };
      },
      // 批量导入
      handleImport() {
        this.$refs.siruiUpload.openDialog(true);
      },
      dblclickEvent(e) {
        this.$baseRequest.linkRouteUrl(
          '/production/productionDataAdd',
          'productionDataAdd',
          '修改产品主数据明细',
          { id: e.row.id, isEdit: 'Y' }
        );
      },
      changeCompany() {},
      showChild(row) {
        //["2342(234234)", "1(133)", "2(3)"]
        /* if(row.confimProductNameSpec==null)
        return;
      let result = row.confimProductNameSpec.split(',');
      let arr = [];
      for(let item of result){
        arr.push({productName:item.split('(')[0],productSpec:item.split('(')[1].split(')')[0]});
      }
      return arr; */
        return row.pdProductAliasList;
      },
    },
  };
</script>
<style scoped>
  .childDataTable {
    width: 1000px !important;
  }
</style>
